import { ActionableCollection } from "common/collections/actionableCollection";
import { CredentialsModel } from "./credentialsModel";

export const CredentialsCollection = ActionableCollection.extend({
    model: CredentialsModel,
    url: "/credentials"
});
